import React from 'react';
import { formatSats, formatPercent } from '../utils/format';

function StatsCards({ dashboard }) {
  const periods = [
    { key: 'today_stats', title: 'Today' },
    { key: 'week_stats', title: 'This Week' },
    { key: 'month_stats', title: 'This Month' },
    { key: 'all_time_stats', title: 'All Time' }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {periods.map(({ key, title }) => {
        const stats = dashboard[key];
        const isProfit = stats.net_profit >= 0;
        return (
          <div key={key} className="bg-zinc-900 border-2 border-zinc-700 rounded-lg p-6 shadow">
            <h3 className="text-lg font-semibold text-white mb-4">{title}</h3>
            <div className="space-y-3">
              <div>
                <p className="text-xs text-gray-400">Total Bets</p>
                <p className="text-2xl font-bold text-white">{stats.total_bets}</p>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <p className="text-xs text-gray-400">Wins</p>
                  <p className="text-lg font-semibold text-orange-400">{stats.total_wins}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-400">Losses</p>
                  <p className="text-lg font-semibold text-red-400">{stats.total_losses}</p>
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-400">Income (Bets Received)</p>
                <p className="text-lg font-semibold text-white">{formatSats(stats.total_income)} sats</p>
              </div>
              <div>
                <p className="text-xs text-gray-400">Outcome (Payouts Sent)</p>
                <p className="text-lg font-semibold text-white">{formatSats(stats.total_payout)} sats</p>
              </div>
              <div className="pt-2 border-t-2 border-zinc-700">
                <p className="text-xs text-gray-400">Net Profit</p>
                <p className={`text-2xl font-bold ${isProfit ? 'text-orange-400' : 'text-red-400'}`}>
                  {isProfit ? '+' : ''}{formatSats(stats.net_profit)} sats
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-400">Win Rate</p>
                <p className="text-sm font-semibold text-gray-300">{formatPercent(stats.win_rate)}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default StatsCards;
